export const LAST_USED_PHONE_ISD_STORAGE_KEY = "signin:lastUsedCountryCode";

export interface LocalStorageService {
  getLastUsedPhoneIsd(): string | null;
  setLastUsedPhoneIsd(isd: string): void;
}

export function createLocalStorageService(
  storage: Pick<Storage, "getItem" | "setItem"> | undefined = typeof window !==
  "undefined"
    ? window.localStorage
    : undefined,
): LocalStorageService {
  return {
    getLastUsedPhoneIsd(): string | null {
      return storage?.getItem(LAST_USED_PHONE_ISD_STORAGE_KEY) || null;
    },

    setLastUsedPhoneIsd(isd: string): void {
      storage?.setItem(LAST_USED_PHONE_ISD_STORAGE_KEY, isd);
    },
  };
}

export const localStorageService = createLocalStorageService();
